export default "__VITE_ASSET__CVvCcdqq__"